import svgUrl from "ni:svgr;YXPel4r1TNK6ui8RATGyLwxo6X_9JdYUJfA3DBetF1U";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UnionMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="var(--tbl--colors--icons--transformation--primary)" fillRule="evenodd" d="M11.375 10.72a1 1 0 0 1 1.25 0l2.5 2a1 1 0 0 1-.625 1.78H13V16h5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h5v-1.5H9.5a1 1 0 0 1-.625-1.78l2.5-2Z" clipRule="evenodd" /><rect width={16} height={7} x={4} y={2} fill="var(--tbl--colors--icons--transformation--tertiary)" rx={2} /></svg>;
const Memo = memo(UnionMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "UnionMIcon";
}